export const THANK_YOU_SET_VALUE = 'digiLifeLoanProtection/thankYou/setValue/';

export const REFERENCE_NUMBER_SET_VALUE = THANK_YOU_SET_VALUE + 'referenceNumber';
export const FIRST_NAMES_SET_VALUE = THANK_YOU_SET_VALUE + 'firstNames';
export const RESET_THANK_YOU_DETAILS = THANK_YOU_SET_VALUE + 'reset';

export const setReferenceNumberValue = value => ({ type: REFERENCE_NUMBER_SET_VALUE, value });
export const setFirstNamesValue = value => ({ type: FIRST_NAMES_SET_VALUE, value });
export const resetThankYouDetails=()=>{{ type: RESET_THANK_YOU_DETAILS}}